/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ThumbsDownFilledIcon = /*#__PURE__*/ createSvgIcon(
  'ThumbsDownFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.5 13c-.375 0-.719-.153-1.031-.458C1.156 12.236 1 11.889 1 11.5v-1.188a1.347 1.347 0 01.125-.583l2.48-5.812c.11-.278.29-.5.54-.667.25-.167.536-.25.855-.25h8c.417 0 .77.142 1.063.427.291.285.437.642.437 1.073v7.875c0 .208-.042.406-.125.594a1.61 1.61 0 01-.333.49l-4.188 4.187c-.25.25-.555.41-.916.479-.362.07-.667.028-.917-.125a1.235 1.235 0 01-.615-.792c-.09-.347-.1-.687-.031-1.02L8 13H2.5zm15-10c.403 0 .753.15 1.052.448.299.299.448.65.448 1.052v7c0 .403-.15.754-.448 1.052A1.44 1.44 0 0117.5 13a1.44 1.44 0 01-1.052-.448A1.44 1.44 0 0116 11.5v-7c0-.403.15-.753.448-1.052A1.44 1.44 0 0117.5 3z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ThumbsDownFilledIcon;
